module.exports = __webpack_public_path__ + "static/flag-03759bfdaa15fe41d7bba346f0903235.png";